import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Anchor, Button, ScrollArea } from '@mantine/core'
import { useSelector } from 'react-redux'
import parse from 'html-react-parser'
import InputCheckbox from 'components/UI/Inputs/InputCheckbox/InputCheckbox'
import Logo from 'components/UI/Logo/Logo'
import PageLoader from 'components/UI/PageLoader/PageLoader'
import { showNotifications } from 'utils/showNotifications'
import styles from './styles.module.scss'

const CheckboxLabel = ({ instanceCountryCode }) => (
    <>
        He leído y acepto la{' '}
        <Anchor href='/aviso-de-privacidad' color='purple.0'>
            Política de Privacidad
        </Anchor>{' '}
        y los{' '}
        <Anchor href='/terminos-y-condiciones' color='purple.0'>
            Términos y Condiciones
        </Anchor>{' '}
        {instanceCountryCode === 'ar'
            ? 'del programa de Soporte al Paciente de Bristol Myers Squibb.'
            : 'del programa de apego al tratamiento de Bristol Myers Squibb.'}
    </>
)

const PatientInformedConsentLegalNotice = ({
    pageData,
    projectAuthNumber,
    instanceCountryCode,
}) => {
    const { colorScheme } = useSelector((state) => state.settings)
    const [termsAccepted, setTermsAccepted] = useState(false)
    const [dataConsentAccepted, setDataConsentAccepted] = useState(false)
    const navigate = useNavigate()

    const handleContinue = () => {
        if (!termsAccepted || !dataConsentAccepted) {
            showNotifications({
                type: 'danger',
                title: 'Error',
                message:
                    'Debe aceptar los términos y condiciones del sitio web para continuar.',
            })
            return
        }
        navigate('/consentimiento-informado-pacientes')
    }

    if (!pageData) return <PageLoader />

    return (
        <div className={styles.layout}>
            <div className={styles.card}>
                <div className={styles.logo}>
                    <Logo logo='bmsLogo' theme={colorScheme} />
                </div>
                <div className={styles.title}>{pageData.data.title}</div>
                <div className={styles.disclaimer}>
                    <ScrollArea h='100%' type='always' offsetScrollbars>
                        {parse(pageData.data.summary)}
                    </ScrollArea>
                </div>
                <InputCheckbox
                    handleCheckboxChange={setTermsAccepted}
                    initialValue={false}
                    label={
                        <CheckboxLabel
                            instanceCountryCode={instanceCountryCode}
                        />
                    }
                    name='terms'
                />
                <InputCheckbox
                    handleCheckboxChange={setDataConsentAccepted}
                    initialValue={false}
                    label='Presto mi consentimiento previo, expreso e informado para que mis datos personales sean tratados conforme a los fines y condiciones aquí establecidos.'
                    name='dataConsent'
                />
                <Button fullWidth onClick={handleContinue} variant='filled'>
                    Acepto y continuar
                </Button>
                <div className={styles.authNumber}>
                    {instanceCountryCode === 'mx'
                        ? `Número de aviso SSA: ${projectAuthNumber}`
                        : `Autorización No. SSA: ${projectAuthNumber}`}
                </div>
            </div>
            <div className={styles.slide}>&nbsp;</div>
        </div>
    )
}

export default PatientInformedConsentLegalNotice
